import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import sessionImage from "../../assets/images/session.png";
import { useStartSession, useCurrentSession } from "@/hooks/useSession";
import QueryStateWrapper from "@/components/ui/QueryStateWrapper";
import { toast } from "react-toastify";
import { logout } from "@/hooks/useAuth";

const StartSession = () => {
  const navigate = useNavigate();
  const { mutate: startSession, isPending: isStarting } = useStartSession();
  const {
    data: sessionData,
    isLoading: isLoadingSession,
    error: sessionError,
  } = useCurrentSession();

  const handleStartSession = () => {
    // تنظيف أي بيانات قديمة من جلسة سابقة
    localStorage.removeItem("sessionStarted");

    if (sessionData?.is_active) {
      localStorage.setItem("sessionStarted", "true");
      localStorage.setItem("sessionStartedAt", String(Date.now()));
      navigate("/");
      return;
    }

    startSession(undefined, {
      onSuccess: () => {
        localStorage.setItem("sessionStarted", "true");
        localStorage.setItem("sessionStartedAt", String(Date.now()));
        navigate("/");
        toast.success("تم بدء جلسة جديدة بنجاح");
      },
      onError: (err: any) => {
        const apiMsg = err?.response?.data?.[0] || "";
        if (typeof apiMsg === "string" && apiMsg.includes("active session")) {
          toast.info("هناك جلسة نشطة بالفعل");
          // بما أن هناك جلسة نشطة فعلاً على السيرفر، نعتبرها نشطة محلياً ونتقدم
          localStorage.setItem("sessionStarted", "true");
          localStorage.setItem("sessionStartedAt", String(Date.now()));
          navigate("/");
        } else {
          toast.error("فشل في بدء الجلسة، حاول مرة أخرى");
        }
      },
    });
  };

  const handleLogout = () => {
    // تسجيل الخروج اليدوي من صفحة بدء الجلسة
    logout();
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    // إن كانت هناك جلسة نشطة من الخادم → ادخل مباشرة للمنزل
    if (sessionData?.is_active) {
      localStorage.setItem("sessionStarted", "true");
      localStorage.setItem("sessionStartedAt", String(Date.now()));
      navigate("/");
    }
  }, [sessionData, navigate]);

  const hasActiveSession = !!sessionData?.is_active;

  return (
    <QueryStateWrapper isLoading={isLoadingSession} isError={!!sessionError}>
      <div className='min-h-screen flex flex-col justify-center items-center p-6 space-y-6 bg-white'>
        <img src={sessionImage} alt='Start Session' className='w-64 h-auto' />

        <h1 className='text-2xl font-bold text-red-700 text-center'>
          {hasActiveSession ? "الجلسة نشطة" : "ابدأ جلستك الآن"}
        </h1>

        <div className='w-full max-w-xs flex flex-col gap-3'>
          <Button
            type='primary'
            onClick={handleStartSession}
            className='w-full'
            disabled={isStarting}
          >
            {isStarting ? "جاري البدء..." : "ابدأ الآن"}
          </Button>

          <Button type='secondary' onClick={handleLogout} className='w-full'>
            تسجيل خروج
          </Button>
        </div>
      </div>
    </QueryStateWrapper>
  );
};

export default StartSession;
